var _mask, _rect, _rect2, _rect3, _mask2, _rect4, _rect5, _rect6, _mask3, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileTopic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2068_28091",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.92253,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.92253,
    rx: 1,
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_2068_28091)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 1.00391,
    width: 16.875,
    height: 1.5,
    rx: 0.752641,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 5.01758,
    width: 7.5,
    height: 1.5,
    rx: 0.752641,
    fill: "currentColor"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_2068_28091",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 11.0391,
    width: 7.5,
    height: 7.92253,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 11.0391,
    width: 7.5,
    height: 7.92253,
    rx: 1,
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-4-inside-2_2068_28091)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 12.043,
    width: 20.625,
    height: 1.5,
    rx: 0.752641,
    fill: "currentColor"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 16.0566,
    width: 13.125,
    height: 1.5,
    rx: 0.752641,
    fill: "currentColor"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_2068_28091",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 22.0781,
    width: 7.5,
    height: 7.92253,
    rx: 1
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 22.0781,
    width: 7.5,
    height: 7.92253,
    rx: 1,
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-7-inside-3_2068_28091)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 23.082,
    width: 18.75,
    height: 1.5,
    rx: 0.752641,
    fill: "currentColor"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.375,
    y: 27.0938,
    width: 15,
    height: 1.5,
    rx: 0.752641,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileTopic);
export default __webpack_public_path__ + "static/media/profile-topic.f273a9f8fbba7145a17d573db6144d29.svg";
export { ForwardRef as ReactComponent };